import Query from '../../components/Report';

const query = new Query('discover-stats-discover');

export default query;
